import React from "react";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    className="btn dropdown-toggle dropdown-toggle-split"
    onClick={(e) => { e.preventDefault(); onClick(e); }}
    style={{
      borderBottomRightRadius: "50px", borderTopRightRadius: "50px",
      border: "1px solid #5FD0F3", background: "#5FD0F3",
      color: "#fff", boxShadow: "none",
    }}
  >
    {children}
  </button>
));

export default CustomToggle;
